/* =============================================================================
 * M.M.LaFleur — colourway swatch hover.
 *
 * Updates the colour name beside the "Color" eyebrow as the pointer moves
 * across the swatch row, and on a sale colourway appends that colourway's own
 * discounted price.
 *
 * WHY THIS FILE EXISTS. mm-editorial.js attaches mouseenter/mouseleave to each
 * swatch AS IT BUILDS THE NODE. snippets/mm_color_row.liquid renders the row
 * server-side, so those swatches never got listeners and the name line sat
 * frozen at the current colourway. Since the server path covers every style
 * with an `exchange-*` collection — which is most of them — hover was in
 * practice dead on the PDP. This restores it for the rendered row without
 * touching mm-editorial.js, which is 30KB and past the safe retransmit size.
 *
 * DELEGATED FROM document, and guarded against double binding, because Platter
 * re-executes assets around a Barba container swap. A listener bound per node
 * would be lost on every soft navigation; a document-level one survives.
 *
 * THE PRICE IS PER SWATCH, not read off the tier heading. Merchandising can
 * discount one colourway harder than another, so the heading shows a range
 * while the swatch carries its own figure — the specific number is the point
 * of hovering.
 * ========================================================================== */

(function () {
  "use strict";

  if (window.__mmSwatchHoverBound) return;
  window.__mmSwatchHoverBound = true;

  /* The name element lives in the block head, above BOTH tiers, so it is found
     by walking up to the shared .mm-pdp-block rather than to the row. */
  function nameFor(swatch) {
    var block = swatch.closest(".mm-pdp-block");
    return block ? block.querySelector("[data-mm-color-name]") : null;
  }

  /* The resting value is written to data-mm-default by the snippet. Falling
     back to the element's own text covers a row rendered by some other path. */
  function restingText(el) {
    var stored = el.getAttribute("data-mm-default");
    if (stored !== null) return stored;
    stored = el.textContent.trim();
    el.setAttribute("data-mm-default", stored);
    return stored;
  }

  var active = null;

  function clear() {
    if (!active) return;
    var el = nameFor(active);
    if (el) el.textContent = restingText(el);
    active = null;
  }

  function apply(swatch) {
    var el = nameFor(swatch);
    if (!el) return;
    restingText(el);
    var label = swatch.getAttribute("data-mm-label");
    /* textContent, not innerHTML — the label carries a colour name that comes
       from a catalogue tag, and there is no markup in it worth the risk. */
    if (label) el.textContent = label;
  }

  /* One handler for pointer and keyboard. Tracking the active swatch and
     returning early when it has not changed keeps this to a single closest()
     call per mouseover rather than a DOM sweep on every pixel of travel. */
  function move(event) {
    if (!event.target || !event.target.closest) return;
    var swatch = event.target.closest("[data-mm-swatch]");
    if (swatch === active) return;
    clear();
    if (swatch) {
      active = swatch;
      apply(swatch);
    }
  }

  document.addEventListener("mouseover", move);
  document.addEventListener("focusin", move);

  /* Leaving the document entirely fires no mouseover, so the last hovered
     swatch would stay latched. */
  document.addEventListener("mouseleave", clear);
  window.addEventListener("blur", clear);
}());
